export default __webpack_public_path__ + "img/dXGfbtoU.d2c916b1.svg";